/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function DialogConfirmation({
    showDialog,
    onCancel,
    onConfirm,
    title,
    description,
    extraContent = null,
    disabled = false,
    loading = false,
}) {
    useEffect(() => {}, [extraContent]);
    return (
        <Transition.Root show={showDialog} as={Fragment}>
            <Dialog as="div" className="relative z-30" onClose={onCancel}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                <div>
                                    <div className="flex items-center justify-center w-12 h-12 mx-auto bg-yellow-100 rounded-full">
                                        <ExclamationCircleIcon
                                            className="w-6 h-6 text-red-600"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-5">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {title}
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                {description}
                                            </p>
                                        </div>

                                        <div className="max-h-screen overflow-auto">
                                            {extraContent !== null && (
                                                <p className="text-sm text-gray-500">
                                                    "The following services will be
                                                    affected:"
                                                </p>
                                            )}
                                            {
                                                <ul className="m-5 text-xs text-justify list-decimal">
                                                    {extraContent !== null &&
                                                        extraContent.map((item) => (
                                                            <li>
                                                                {item.clientName} -{" "}
                                                                <span className="font-semibold">
                                                                    {item.taxId}
                                                                </span>
                                                            </li>
                                                        ))}
                                                </ul>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between mt-5 sm:mt-6">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-2 py-2 mx-2 text-base font-medium text-white bg-red-500 border border-transparent rounded-md shadow-sm hover:bg-orange-600 focus:outline-none focus:ring-0 sm:text-sm"
                                        onClick={() => {
                                            onCancel();
                                        }}
                                        disabled={disabled}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-2 py-2 mx-2 text-base font-medium text-white bg-teal-500 border border-transparent rounded-md shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0 sm:text-sm"
                                        onClick={() => {
                                            onConfirm();
                                        }}
                                        disabled={disabled}
                                    >
                                        {loading && (
                                            <div className="w-4 h-4 mr-2 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
                                        )}
                                        {loading ? "Updating..." : "Confirm"}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
